import axios, { resHandle } from "@/plugins/axios";



/**
 * @description 习题库：习题列表页
 * @param vCom Vue组件
 */
const GetQuestionList$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/questions", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 习题库：题型列表
 * @param vCom Vue组件
 */
const GetAllCates$ = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/question/cates").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 习题库：题型编辑或创建
 * @param vCom Vue组件
 */
const ComposeCates$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/question/cates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 习题库：创建或编辑习题
 * @param vCom Vue组件
 */
const ComposeQuestion$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/question", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 习题库：习题详情
 * @param vCom Vue组件
 */
const GetQuestionDetail$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/question", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 习题库：删除习题
 * @param vCom Vue组件
 */
const DeleteQuestion$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/edu/question", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 习题库：批量删除
 * @param vCom Vue组件
 */
const DeleteQuestions$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/edu/questions", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 试卷库：试卷列表页
 * @param vCom Vue组件
 */
const GetTestList$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/tests", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 试卷库：删除试卷
 * @param vCom Vue组件
 */
const DeleteTest$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/edu/test", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 试卷库：试题分类 下拉列表
 * @param vCom Vue组件
 */
const GetCatesInTest$ = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/test/question/cates").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 试卷库：创建/编辑 试卷
 * @param vCom Vue组件
 */
const ComposeTest$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/test", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 试卷库：删除试题、批量删除试题
 * @param vCom Vue组件
 */
const DeleteQustionsInTest$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/edu/test/question", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 试卷库：编辑试题分数
 * @param vCom Vue组件
 */
const ChangeFenshu$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/test/question/score", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 试卷库：试卷详情
 * @param vCom Vue组件
 */
const GetTestDetail$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/test", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 试卷库：试题列表页
 * @param vCom Vue组件
 */
const GetTestQuestionsList$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/test/questions", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 班级管理：学生列表页
 * @param vCom Vue组件
 */
const GetStudentsList$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/students", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 班级管理：班级列表
 * @param vCom Vue组件
 */
const GetAllBanjis$ = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/classes").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 班级管理：删除学生、批量删除学生
 * @param vCom Vue组件
 */
const DeleteStudents$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/edu/students", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};



/**
 * @description 班级管理：新增班级
 * @param vCom Vue组件
 */
const ComposeBanji$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/classes", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 班级管理：添加/编辑学生
 * @param vCom Vue组件
 */
const ComposeStudent$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/student", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 班级管理：学生详情
 * @param vCom Vue组件
 */
const GetXsDetail$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/student", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 考试管理：考试列表页
 * @param vCom Vue组件
 */
const GetExamList$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/exams", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 考试管理：删除考试
 * @param vCom Vue组件
 */
const DeleteExams$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/edu/exams", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 考试管理：新建、编辑考试
 * @param vCom Vue组件
 */
const ComposeExam$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/exam", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 考试管理：考试详情（舌诊考试的考试详情页 也用到该接口）
 * @param vCom Vue组件
 */
const GetExamDetail$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/exam", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};



/**
 * @description 考试管理：成绩列表页
 * @param vCom Vue组件
 */
const GetResultList$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/exam/replys", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 考试管理：考试统计
 * @param vCom Vue组件
 */
const GetResultAnalysis$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/exam/stats", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 试卷库：试卷列表(下拉菜单)
 * @param vCom Vue组件
 */
const GetAllTest$ = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/tests").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


export {
    GetQuestionList$, GetAllCates$, ComposeCates$, ComposeQuestion$, GetQuestionDetail$, DeleteQuestion$, DeleteQuestions$,
    GetTestList$, DeleteTest$, GetCatesInTest$, ComposeTest$, GetTestDetail$, GetTestQuestionsList$, DeleteQustionsInTest$, ChangeFenshu$,
    GetStudentsList$, GetAllBanjis$, DeleteStudents$, ComposeBanji$, ComposeStudent$, GetXsDetail$,
    GetExamList$, DeleteExams$, ComposeExam$, GetExamDetail$, GetAllTest$, GetResultList$, GetResultAnalysis$
};

